const Terms = () => {
  return (
    <iframe
      src="https://macodi-asset.s3.ap-northeast-2.amazonaws.com/macodi_terms_of_use.pdf"
      width="100%"
      height="100%"
      title="이용약관"
    />
  );
};

export default Terms;
